import { hasResolvedRideLocation } from "@be-miniapp/shared"

import { useClientInfo } from "@/store/client-info"
import { useUserPersistingData } from "@/store/user-persisting-data"
import { useUserStore } from "@/store/user-session"

export async function waitForUserPersistingDataHydration(
  timeoutMs = 2000
): Promise<boolean> {
  if (useUserPersistingData.getState()._hasHydrated) {
    return true
  }

  return new Promise((resolve) => {
    const timeoutId = window.setTimeout(() => {
      resolve(useUserPersistingData.getState()._hasHydrated)
    }, timeoutMs)

    const finishHydration = () => {
      window.clearTimeout(timeoutId)
      resolve(true)
    }

    useUserPersistingData.persist.onFinishHydration(finishHydration)
  })
}

export function hydratePersistedLocationToRuntime(): boolean {
  const {
    location,
    locationAddress,
    locationPermissionState,
    isLocationManuallyChanged,
    lastLocationTimestamp,
  } = useUserPersistingData.getState()

  if (
    !hasResolvedRideLocation({
      location,
      address: locationAddress,
      isLocationManuallyChanged,
      lastLocationTimestamp,
      locationPermissionStatus: locationPermissionState.status,
    })
  ) {
    return false
  }

  if (!location || !locationAddress) {
    return false
  }

  useClientInfo.getState().setLocation(location, "manual")
  useUserStore.getState().setLocation(location.latitude, location.longitude)
  useUserStore.getState().setUserAddress(locationAddress)

  return true
}
